import { Box, Button } from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import DeleteIcon from '@mui/icons-material/Delete';

interface ReviewActionButtonsProps {
  onDisapprove: () => void;
  onApprove: () => void;
  onDelete: () => void;
  showApprove?: boolean;
  showDisapprove?: boolean;
  showDelete?: boolean;
}

const ReviewActionButtons: React.FC<ReviewActionButtonsProps> = ({
  onDisapprove,
  onApprove,
  onDelete,
  showApprove = true,
  showDisapprove = true,
  showDelete = true,
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {showApprove && (
        <Button
          variant="contained"
          color="warning"
          startIcon={<ThumbUpIcon />}
          onClick={onApprove}
          size="small"
          sx={{ textTransform: 'none' }}
        >
          Approve
        </Button>
      )}
      {showDisapprove && (
        <Button
          variant="contained"
          color="error"
          startIcon={<ThumbDownIcon />}
          onClick={onDisapprove}
          size="small"
          sx={{ textTransform: 'none' }}
        >
          Disapprove
        </Button>
      )}
      {showDelete && (
        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={onDelete}
          size="small"
          sx={{ textTransform: 'none' }}
        >
          Delete
        </Button>
      )}
    </Box>
  );
};

export default ReviewActionButtons;
